<template>
  <div class="search">
    <input class="" type="text" :placeholder="placeholder" v-model="term">
    <p class="helptext">Пошук за ПІБ лікаря, назва лікарні, адреса лікарні, назва населеного пункту, назва ОТГ, область,
      назва препарату</p>

    <!-- <div v-else class="pseudo-input">
        <div class="selected-term">{{selected_term}} </div> <div class="btn-close" @click="() => term_selected(null)">✕</div>
    </div> -->

  </div>
</template>

<script>
export default {
  name: "SearchField",
  props: ["placeholder"],

  data() {
    return {
      term: "",
    }
  },

  computed: {
    real_term() {
      if (this.term.trim().length < 3) return null;
      return this.term.trim();
    }
  },

  watch: {
    real_term(val) {
      this.$emit("changed", val);
    }
  }
}
</script>


<style lang="scss" scoped>

.search {
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 1em;

  border-radius: 0;
  font-weight: 300 !important;
  // overflow: hidden;

  input, .pseudo-input {
    background: #E4E6EE;
    font-weight: 600 !important;
    width: 100%;

    color: #a6afca !important;
    height: 100%;
    border-radius: 0;
    border: 1px solid white;

    padding: 0.25rem 0.5rem;

    font-size: 1em;
  }

  input::placeholder {
    color: #a6afca;
  }

  .helptext {
    font-style: italic;
    color: white;
    font-weight: 400;
  }

  .pseudo-input {
    display: flex;
    align-items: center;

    .selected-term {
      background-color: var(--col-orange);
      border-radius: 0.25rem;
      padding: 0 0.5em;
      color: white;
      font-weight: 600;

    }

    .btn-close {
      background-color: var(--col-orange);
      width: 1.5em;
      height: 1.5em;
      line-height: 1.5em;
      text-align: center;
      border-radius: 50%;
      cursor: pointer;
      margin-left: 0.25em;

      &:hover {
        background-color: black;
        color: white;
      }
    }
  }

  input::placeholder {
    opacity: 0.5;
  }

  // .suggestions {
  //     display: flex;
  //     flex-direction: column;
  //     background-color: white;
  //     color: black;
  //     width: 100%;
  //     z-index: 1000;

  //     // border: 1px solid black;
  //     border-top: none;
  //     position: absolute;
  //     top: 100%;

  //     font-size: 1rem;

  //     > * {
  //         padding-left: 0.3rem;
  //     }

  //     a {
  //         cursor: pointer;
  //         padding: 0.3rem;
  //         // padding-left: 0.3rem;
  //         text-decoration: none;

  //         &:hover {
  //             background-color: #e7eef3;
  //         }

  //         ::v-deep .match {
  //             font-weight: 600;
  //         }
  //     }

  //     .supressed {
  //         color: rgb(90, 90, 90);
  //         display: flex;
  //         flex-direction: column;
  //         background-color: white;
  //         color: black;
  //         width: 100%;

  //         border: 1px solid white;
  //         position: absolute;
  //         top: 100%;

  //         // font-size: 1rem;

  //         > * {
  //             padding-left: 0.3rem;
  //         }

  //         a {
  //             padding-left: 0.3rem;
  //             text-decoration: none;
  //             padding: 1em;

  //             &:hover {
  //                 background-color: var(--col-salmon);
  //             }

  //             ::v-deep .match {
  //                 font-weight: 700;
  //             }
  //         }
  //     }
  // }
}
</style>